import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { interceptors } from './services/http-interceptors/interceptors';



@NgModule({
  providers:[
    interceptors,

  ],
  declarations: [],
  imports: [
    CommonModule,
  ],
  exports:[

  ]
})
export class CoreModule { }
